/* eslint-env browser */

(function (window, document) {
    document.addEventListener('click', function (event) {
        var btn = event.target.closest('.gh-button-share');
        if (!btn) return;

        var url = btn.dataset.shareUrl || window.location.href;
        var title = btn.dataset.shareTitle || document.title;

        if (navigator.share) {
            navigator.share({title: title, url: url}).catch(function () {});
            return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () {
                var original = btn.textContent;
                btn.textContent = 'Link kopiert!';
                setTimeout(function () {
                    btn.textContent = original;
                }, 2000);
            }).catch(function () {});
        }
    });
})(window, document);
